import React from "react"
import { Button, Grid, Paper } from "@mui/material"
import { Box } from "@mui/system"
import { useDispatch, useSelector } from "react-redux"
import {
  meetingPointsToDescription,
  setSelectedLessonType,
} from "../../../actions/searchActions"
import { RootState } from "../../../store/configureStore"
import { lessonTypes } from "../../../content"
import { LessonTypeName, StateMeta } from "../../../types"
import CMSContent from "../CMSContent"

type StateMetaWithId = StateMeta & { id: LessonTypeName }

const LessonTypePicker = ({
  setHasChosenLessonType,
}: {
  setHasChosenLessonType: (arg: boolean) => void
}) => {
  const dispatch = useDispatch()
  const { meetingPoints } = useSelector((state: RootState) => state.search)
  const { searchState } = useSelector((state: RootState) => state.location)!
  const searchStateLower = searchState?.toLowerCase() ?? ""
  const stateLessonTypeMetas = Object.values(lessonTypes)
    .filter((lessonType) =>
      Object.keys(lessonType.stateMeta).includes(searchStateLower),
    )
    .map(
      (lessonType) =>
        ({
          ...lessonType.stateMeta[searchStateLower],
          id: lessonType.name,
        }) as StateMetaWithId,
    )

  const handleLessonTypeChosen = (lessonName: LessonTypeName) => {
    dispatch(setSelectedLessonType(lessonTypes[lessonName]))
    setHasChosenLessonType(true)
  }

  return (
    <Grid container spacing={2}>
      {stateLessonTypeMetas.map((item) => (
        <Grid item key={item.id} xs={6}>
          <Paper
            style={{
              padding: 20,
              cursor: "pointer",
            }}
            onClick={() => handleLessonTypeChosen(item.id)}
            role="button"
            tabIndex={0}
            className="mini-package-block"
          >
            <Box display="flex">
              <div style={{ marginRight: 10 }}>{item.icon}</div>
              <h3 style={{ marginTop: 0 }}>{item.title} Lessons</h3>
            </Box>
            <p>{item.description}</p>
            {meetingPoints?.some((point) => point.meetingPointId !== "home") &&
              item.id === "shared" && (
                <p>
                  <i>
                    Our meeting locations near you:{" "}
                    {meetingPointsToDescription(meetingPoints, false)}
                  </i>
                </p>
              )}
            {item.additionalContentId ? (
              <CMSContent uid={item.additionalContentId} />
            ) : null}
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleLessonTypeChosen(item.id)}
            >
              Choose {item.title}
            </Button>
          </Paper>
        </Grid>
      ))}
    </Grid>
  )
}

export default LessonTypePicker
